import { render, staticRenderFns } from "./EmergencyDisposalCard.vue?vue&type=template&id=96dd9cc8&scoped=true"
import script from "./EmergencyDisposalCard.vue?vue&type=script&lang=js"
export * from "./EmergencyDisposalCard.vue?vue&type=script&lang=js"
import style0 from "./EmergencyDisposalCard.vue?vue&type=style&index=0&id=96dd9cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dd9cc8",
  null
  
)

export default component.exports